import { ErrorBoundary as InternalErrorBoundary, type FallbackProps } from 'react-error-boundary';
import { ToolCallContainer } from './ToolCallContainer';
import type { ToolCallSummary } from '@/features/types/tools';
import { ToolCallContentBox } from './ToolCallContentBox';

type ToolCallErrorBoundaryProps = {
  children: React.ReactNode;
  toolCall: ToolCallSummary;
};

const ToolCallErrorFallback = (boundaryProps: FallbackProps & { toolCall: ToolCallSummary }) => {
  const { toolCall } = boundaryProps;

  const tabs = [
    {
      id: 'results',
      label: 'Results',
      showLoadingWhileRunning: true,
      content: (
        <ToolCallContentBox
          content={
            'results' in toolCall
              ? typeof toolCall.results === 'string'
                ? toolCall.results
                : JSON.stringify(toolCall.results)
              : ''
          }
        />
      ),
    },
  ];

  return (
    <ToolCallContainer
      toolName={toolCall.name}
      title={toolCall.name}
      isRunning={toolCall.isRunning}
      tabs={tabs}
    />
  );
};

export const ToolCallErrorBoundary = ({ children, toolCall }: ToolCallErrorBoundaryProps) => {
  return (
    <InternalErrorBoundary
      FallbackComponent={props => <ToolCallErrorFallback {...props} toolCall={toolCall} />}
    >
      {children}
    </InternalErrorBoundary>
  );
};

export default ToolCallErrorBoundary;
